/* 
  Provider-specific nested alphabetization of resources and properties

  Canvas + BB switch name for type right now

  Salesforce adds "fake" Lingk External Id to each resource (createLingkExternalIds action)
  Salesforce also adds new virtual resources for Record Type Id differences
*/


export function metadataFunctions(r, providerType){

  let res;
  // if the metadata comes in an array
  if(Array.isArray(r)){
    res = r
  } else if(r.resources){
    // if the metadata is an object with a "resources" property array
    res = r.resources
  }

  var meta = null
  switch (providerType) {

    /*case 'Banner':
      if(res){
        var bannerResources = []
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          bannerResources.push(rsc)
        })
        meta = bannerResources
      }
      break;*/

    /*case 'Moodle':
      if(res){
        var moodleResources = []
        res.resources.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          moodleResources.push(rsc)
        })
        meta = moodleResources
      }
      break;*/

    /*case 'LingkAdapter':
      if(res){
        var lingkResources = []
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          lingkResources.push(rsc)
        })
        meta = lingkResources
      }
      break;*/

    /*case 'Colleague':
      if(res){
        var colleagueResources = []
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          colleagueResources.push(rsc)
        })
        meta = colleagueResources
        meta.sort(function(a, b){
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        })
      }
      break;*/

    case 'Canvas':
      if(res){
        var canvasResources = []
        // sort properties
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a && b){
              if(a.label < b.label) return -1;
              if(a.label > b.label) return 1;
            }
            return 0;
          })
          canvasResources.push(rsc)
        })
        // sort resources
        canvasResources.sort(function(a, b){
          if(a.type < b.type) return -1;
          if(a.type > b.type) return 1;
          return 0;
        })

        // sort nesting of resources
        meta = []
        canvasResources = canvasResources.map(r=>{
          if(r && !r.parentRef) {
            meta.push([{...r, name: r.type, apiName: r.name}])
            return null
          }
          return r
        })
        canvasResources = canvasResources.map(r=>{
          if(r && r.parentRef.length === 1) {
            const parentString = r.parentRef[0].ref.split('/')[2]
            const parentIndex = meta.findIndex(r=>r[0].type===parentString)
            if(parentIndex>-1){
              meta[parentIndex].push([{...r, name: r.type, apiName: r.name}])
              return null
            }
          }
          return r
        })
        canvasResources = canvasResources.map(r=>{
          if(r && r.parentRef.length === 2) {
            const grandParentString = r.parentRef[1].ref.split('/')[2]
            const grandParentIndex = meta.findIndex(r=>r[0].type===grandParentString)
            if(grandParentIndex>-1){
              const parentString = r.parentRef[0].ref.split('/')[2]
              const parentIndex = meta[grandParentIndex]
                .findIndex(r=>r[0] && r[0].type===parentString)
              if(parentIndex>-1){
                meta[grandParentIndex][parentIndex].push([{...r, name: r.type, apiName: r.name}])
                return null
              }
              return r
            }
          }
          return r
        })
        meta = flatten(meta)
      }
      break;

    /*case 'PeopleSoft':
      if(res){
        var psResources = []
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          psResources.push(rsc)
        })
        meta = psResources
        meta.sort(function(a, b){
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        })
      }
      break;*/

    case 'Blackboard':
      function recurseSort(rsc){
        rsc.properties && rsc.properties.sort((a, b)=>{
          if(a.hasOwnProperty('object') === b.hasOwnProperty('object')) {
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          } else if(a.hasOwnProperty('object'))
            return -1;
          else return 1;
        })
        rsc.properties && rsc.properties.forEach(p=>{
          if(p.object){
            recurseSort(p.object)
          }
        })
        return rsc
      }
      if(res){
        var blackboardResources = []
        res.forEach(rsc=>blackboardResources.push(recurseSort(rsc)))
        blackboardResources.sort(function(a, b){
          if(a.type < b.type) return -1;
          if(a.type > b.type) return 1;
          return 0;
        })
        meta = []
        blackboardResources = blackboardResources.map(rsc=>{
          if(rsc && !rsc.parentRef) {
            meta.push([{...rsc,name:rsc.type,apiName:rsc.name}])
            return null
          }
          return rsc
        })
        blackboardResources = blackboardResources.map(rsc=>{
          if(rsc && rsc.parentRef && rsc.parentRef.length===1){
            const parentString = rsc.parentRef[0].ref.split('/')[2]
            const index = meta.findIndex(r=>r[0].type===parentString)
            if(index>-1){
              meta[index].push([{...rsc,name:rsc.type,apiName:rsc.name}])
              return null
            }
          }
          return rsc
        })
        blackboardResources = blackboardResources.map(rsc=>{
          if(rsc && rsc.parentRef.length===2){
            const grandParentString = rsc.parentRef[1].ref.split('/')[2]
            const grandParentIndex = meta.findIndex(r=>r[0].type===grandParentString)
            if(grandParentIndex>-1){
              const parentString = rsc.parentRef[0].ref.split('/')[2]
              const parentIndex = meta[grandParentIndex]
                .findIndex(r=>r[0] && r[0].type===parentString)
              if(parentIndex>-1){
                meta[grandParentIndex][parentIndex].push([{...rsc,name:rsc.type,apiName:rsc.name}])
                return null
              }
              return rsc
            }
          }
          return rsc
        })
        meta = flatten(meta)
      }
      break;

    case 'Salesforce':
      var resources = []
      res.forEach((rsc)=>{
        if(!rsc.properties.find(p=>p.name==='Lingk_External_Id__c')){
          rsc.properties.push({
            label:'Lingk External Id',
            name:'Lingk_External_Id__c',
            readOnly:false,
            required:false,
            size:150,
            type:'string',
            updateable:true,
            fake:true,
          })
        }

        rsc.properties && rsc.properties.sort(function(a, b) {
          if(a.required === b.required) {
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          } else if(a.required)
            return -1;
          else return 1;
        })

        if(rsc.metadata && rsc.metadata.recordTypes && rsc.metadata.recordTypes.length > 0) {
          rsc.metadata.recordTypes.forEach((recordType)=>{
            if(recordType.isActive){
              const metadataResource = res.find(r=>r.type===recordType.sobjectType)
              metadataResource && resources.push({
                name: metadataResource.name + ' - ' + recordType.name,
                type: metadataResource.type,
                recordTypeId: recordType.id,
                properties: metadataResource.properties,
                endpointSuffix: metadataResource.endpointSuffix,
              })
            }
          })
        } else {
          resources.push(rsc)
        }
      })
      meta = resources
      meta.sort(function(a, b){
        if(a.name < b.name) return -1;
        if(a.name > b.name) return 1;
        return 0;
      })
      break;

    /*case 'SFTP':
      if(res && res.resources){
        var sftpRsc = []
        res.resources.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          sftpRsc.push(rsc)
        })
        meta = sftpRsc
        meta.sort(function(a, b){
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        })
      }
      break;*/

    /*case 'Ethos':
      if(res && res.resources){
        var ethosRsc = []
        res.resources.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          ethosRsc.push(rsc)
        })
        meta = ethosRsc
        meta.sort(function(a, b){
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        })
      }
      break;*/

    default:
      if(res){
        var rscs = []
        res.forEach(rsc=>{
          rsc.properties && rsc.properties.sort((a, b)=>{
            if(a.label < b.label) return -1;
            if(a.label > b.label) return 1;
            return 0;
          })
          rscs.push(rsc)
        })
        meta = rscs
        meta.sort(function(a, b){
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        })
      }
      break;
  }


  return meta.map(m=>{
    return {
      ...m,
      resourceNameAndProvider:`${m.type}_${providerType}`
    }
  })

}

function flatten(obj){
  return obj.reduce(function(a, b){
    if(isArray(a) && isArray(b)) return flatten(a).concat(flatten(b))
    return a.concat(b);
  }, []);
}

function isArray(a) {
  if( Object.prototype.toString.call(a) === '[object Array]' ) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/lib/reducer/metadataFunctions.js